export default ({ COLORS }) => ({
  answer: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold'
  },
  active: {
    color: COLORS.BLUE.NORMAL
  }
})
